import * as React from 'react';
import { useContext } from 'react';

import type { ProductCardCourseFragmentFragment as Course } from 'bundles/enterprise-legacy-learner-home/queries/__generated__/ProductCoursesQuery';

type EnterpriseAutoEnrolledCoursesContextType = {
  courses?: Course[] | undefined;
  isLoading?: boolean;
};

const EnterpriseAutoEnrolledCoursesContext = React.createContext<EnterpriseAutoEnrolledCoursesContextType>({});

export const useEnterpriseAutoEnrolledCourses = () => {
  const autoEnrollData = useContext(EnterpriseAutoEnrolledCoursesContext);
  return autoEnrollData.courses;
};

export const useEnterpriseAutoEnrolledCoursesLoading = () => {
  const autoEnrollData = useContext(EnterpriseAutoEnrolledCoursesContext);
  return autoEnrollData.isLoading;
};

export default EnterpriseAutoEnrolledCoursesContext;
